import { html as beautifyHtml } from "js-beautify";

// Clean escaped DB string
export function cleanHtmlString(raw) {
  if (!raw) return "";

  return raw
    .replace(/\\n/g, "\n")
    .replace(/\\"/g, '"')
    .replace(/\\'/g, "'")
    .trim();
}

// Format HTML safely
export function formatHtml(content) {
  try {
    return beautifyHtml(content, {
      indent_size: 2,
      wrap_line_length: 120,
      preserve_newlines: true,
      max_preserve_newlines: 2,
      indent_inner_html: false,
    });
  } catch (err) {
    console.error("Beautify error:", err);
    return content;
  }
}

export function minifyHtml(html) {
  if (!html || typeof html !== "string") return html;

  return html
    .replace(/<!--[\s\S]*?-->/g, "") // remove comments
    .replace(/\s{2,}/g, " ") // collapse spaces
    .replace(/>\s+</g, "><") // remove whitespace between tags
    .trim();
}
